import { createRouter, createWebHashHistory } from 'vue-router';

import Login from "@lib/frontend/pages/Login.vue";
import Signup from "@lib/frontend/pages/Signup.vue";
import Home from '../pages/Home.vue'
import Converter from '../components/Converter.vue'
import UploadData from '../components/UploadData.vue'
import Msc from '../components/Msc.vue'
import Collection from '../components/Collection.vue'
import Admin from '../components/Admin.vue'




const routes = [
  { path: '/', component: Home, name: 'home' },
  { path: '/login', name: 'login', component: Login, props: true, meta: { navbar: false } },
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
    meta: { requiresAuth: false }
  },
  { path: '/convert', name: 'Converter', component: Converter },
  { path: '/upload-data', name: 'UploadData', component: UploadData },
  { path: '/airport-operations', name: 'Msc', component: Msc },
  { path: '/admin', name: 'Admin', component: Admin , meta: { requiresAdmin: true },},
  { path: '/collection', name: 'CreateCollectionType', component: Collection },

];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('authToken');
  const userProfile = JSON.parse(localStorage.getItem('userProfile')) || {};
  const isAdmin = userProfile.role && userProfile.role.name === 'Authenticated';
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
  } else if (to.meta.requiresAdmin && !isAdmin) {
    next('/');
  } else if (to.meta.requiresAuth && to.params.id && String(to.params.id) !== String(userProfile.id) && !isAdmin) {
    next('/');
  } else {
    next();
  }
});

export default router;

